exports = module.exports = require("../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.spinner[data-v-957c79d8] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.spinner *[data-v-957c79d8] {\n    line-height: 0;\n    box-sizing: border-box;\n}\n.spinner-inner[data-v-957c79d8] {\n  width: calc(100% - 14px);\n  height: calc(100% - 14px);\n  flex-shrink: 0;\n  border: 1px solid;\n  animation: rotate 1.3s linear 0s infinite;\n  border-radius: 50%;\n}\n.spinner-inner[data-v-957c79d8]:after {\n    content: '';\n    position: absolute;\n    width: 14px;\n    height: 14px;\n    background: #41b883;\n    border-radius: 100%;\n    left: 50%;\n    transform: translateX(-50%) translateY(-50%);\n    top: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-957c79d8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loading-spinner/node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-loading-spinner/src/components/Circle11.vue
// module id = 311
// module chunks = 2